(function () {
    'use strict';
    /*
     * Copyright (c) 2014-17 In Hand Health.
     * All rights reserved.
     */

    /**
     * @description
     * A filter applied to item chooser results. The behavior of the filter is determined by the item chooser <code>
     * Config</code> object.
     * <p>
     * If local manipulation mode has been set by calling <code>setLocalManipulationMode</code> on the config,
     * then any who filters, filter options, full text filter, and sort options from the config are applied.
     * <p>
     * If <code>setSuppressedItems</code> has been called on the config, then the specified suppressed items are filtered out of
     * the result.
     *
     * @ngdoc filter
     * @memberOf ihh-common-web.ihh-item-chooser
     * @name chooserFilter
     */
    angular
        .module('ihh-common-web')
        .filter('chooserFilter', chooserFilter);

    chooserFilter.$inject = ['$filter', '_'];

    function chooserFilter($filter, _) {
        return function(items, config) {
            var item;
            var isMatch;
            var i, j; // counters
            var results;

            // These filters only apply if local manipulation only mode is active
            if (items && config.localManipOnly && (angular.isUndefined(items.$resolved) || items.$resolved)) {
                items = $filter('orderBy')(items, config.state.sort, config.state.sortReverse);

                for (i = 0; i < items.length; i++) {
                    item = items[i];
                    isMatch = true;

                    var whoProp = config.getWhoPropertyById(config.state.whose);

                    if (isMatch && angular.isDefined(whoProp)) {
                        results = $filter('filter')([item], whoProp);
                        if (results.length <= 0) {
                            isMatch = false;
                        }
                    }

                    var tagFilterOptions = config.state.filters;
                    if (isMatch && angular.isDefined(tagFilterOptions)) {
                        for (var key in tagFilterOptions) {
                            if (tagFilterOptions.hasOwnProperty(key)) {
                                var filterOption = tagFilterOptions[key].filterOption;
                                var filterValue = tagFilterOptions[key].filterValue;
                                var itemValue = item[filterOption.itemProperty];
                                if (angular.isArray(itemValue)) {
                                    var found = false;
                                    for (j = 0; !found && j < itemValue.length; j++) {
                                        if (filterValue[filterOption.matchProperty] === itemValue[j][filterOption.matchProperty]) {
                                            found = true;
                                        }
                                    }

                                    if (!found) {
                                        isMatch = false;
                                    }
                                }
                                else if (!itemValue || filterValue[filterOption.matchProperty] !== itemValue[filterOption.matchProperty]) {
                                    isMatch = false;
                                }
                            }
                        }
                    }

                    if (isMatch) {
                        items[i].hidden = false;
                    }
                    else {
                        items[i].hidden = true;
                    }
                }
            }

            // Suppressed items handling always applies.
            if (items && angular.isArray(config.suppressedItems) && (angular.isUndefined(items.$resolved) || items.$resolved)) {

                for (i = 0; i < items.length; i++) {
                    item = items[i];

                    if (!item.hidden && item.id) {
                        item.hidden = _.findIndex(config.suppressedItems, { id: item.id }) >= 0;
                    }
                }
            }

            return items;
        };
    }
})();